var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactionFailed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 163.375,
    height: 164.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17047"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m107.286 13.292 38.925 38.932v55.055l-38.925 38.932H52.217l-38.925-38.932V52.224l38.925-38.932zM112.789 0H46.715L0 46.715v66.068L46.715 159.5h66.068l46.717-46.711V46.715L112.789 0zM69.783 39.876h19.938l-6.646 53.168h-6.646zm9.969 81.413a8.307 8.307 0 1 1 8.307-8.307 8.31 8.31 0 0 1-8.307 8.307z",
    transform: "translate(3.372 4.496)",
    style: {
      fill: "#3e4252",
      stroke: "#3e4252",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "error",
    d: "m107.286 13.292 38.925 38.932v55.055l-38.925 38.932H52.217l-38.925-38.932V52.224l38.925-38.932zM112.789 0H46.715L0 46.715v66.068L46.715 159.5h66.068l46.717-46.711V46.715L112.789 0zM69.783 39.876h19.938l-6.646 53.168h-6.646zm9.969 81.413a8.307 8.307 0 1 1 8.307-8.307 8.31 8.31 0 0 1-8.307 8.307z",
    style: {
      fill: "#ff5252"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionFailed);
export default __webpack_public_path__ + "static/media/TransactionFailed.842a0929.svg";
export { ForwardRef as ReactComponent };